import { env } from "@/env";

export const CUSTOMER_KEY_COOKIE = "customerKey";
export const SESSION_KEY_COOKIE = "sessionKey";

export const VOYADO_ELEVATE_API_URL = {
  STOREFRONT: `https://${env.NEXT_PUBLIC_ELEVATE_CLUSTER_ID}.api.esales.apptus.cloud/api/storefront/v3`,
  ADMIN: `https://${env.NEXT_PUBLIC_ELEVATE_CLUSTER_ID}.api.esales.apptus.cloud/api/admin/v4`,
};
